document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.medical-services-slider').forEach(el => {
        new Slider(el, el.querySelector('[data-items]'), el.querySelector('[data-navigation-controls]'), el.querySelector('[data-nav]'), {
            count: 1.2,
            mouseDrag: true,
            count568: 2,
            count768: 2,
            count992: 3,
            count1200: 4,
            count1920: 4,
            gutter: 30,
            loop: false
        });
    });
});